import { queryStudioTitlebar } from './read-floating-panel-viewport'

function observeChromeNodes(shell: Element, titlebar: Element, resizeObserver: ResizeObserver) {
  resizeObserver.disconnect()
  resizeObserver.observe(titlebar)
  for (const child of shell.children) {
    if (child === titlebar) {
      break
    }
    resizeObserver.observe(child)
  }
}

export function observeStudioLayoutChrome(onChange: () => void) {
  const titlebar = queryStudioTitlebar()
  const shell = titlebar?.parentElement
  if (!titlebar || !shell) {
    return () => {}
  }

  const resizeObserver = new ResizeObserver(onChange)
  observeChromeNodes(shell, titlebar, resizeObserver)

  const mutationObserver = new MutationObserver(() => {
    observeChromeNodes(shell, titlebar, resizeObserver)
    onChange()
  })
  mutationObserver.observe(shell, { childList: true })

  return () => {
    resizeObserver.disconnect()
    mutationObserver.disconnect()
  }
}
